






















































































import TopToolbar from "@/components/TopToolbar.vue";
import BottomNav from "@/components/BottomNav.vue";
import {
  Data,
  On,
  Route,
  RouteParam,
  Watch
} from "@rocketbase/vue-extra-decorators";
import { Component, Vue } from "vue-property-decorator";
import { ItemWrite, LockerRead, TypeRead } from "@/swagger";

@Route({
  path: "/item/:id",
  name: "itemdetails"
})
@Component({
  components: { TopToolbar, BottomNav }
})
export default class ItemDetails extends Vue {
  @RouteParam("id")
  private id!: string;

  @Data({ default: false })
  private valid!: boolean;

  @Data({ default: "" })
  private name!: string;

  @Data({ default: "" })
  private portions!: string;

  @Data({ default: "" })
  private subject!: string;

  @Data({ default: {} })
  private type!: {
    id: any;
  };

  @Data({ default: 1 })
  private amount!: number;

  @Data({ default: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10] })
  private steps!: [];

  @Data({ default: {} })
  private locker!: LockerRead;

  @Data({ default: [] })
  private types!: TypeRead[];

  @Data({ default: [] })
  private lockers!: LockerRead[];

  @Data({ default: [] })
  private subjects!: Array<string> | undefined;

  @Watch({ prop: "$route", deep: true, immediate: true })
  private async onRouteChange() {
    await this.loadDropdownData();

    const { id } = this;
    if (id === "new") return;

    this.setItemData();
  }

  private async loadDropdownData() {
    const { types, lockers } = this.$store.state;
    if (types != 0 && lockers != 0) {
      this.lockers = lockers;
      this.types = types;
    } else {
      this.lockers = await this.$store.dispatch("getLockers");
      this.types = await this.$store.dispatch("getTypes");
    }
  }

  private setSubject() {
    this.subjects = this.locker.subjects;
  }

  @On("hook:mounted")
  private async before() {
    this.loadDropdownData();

    const { id } = this;
    if (id === "new") return;

    if (id != null) this.setItemData();
  }

  private async create() {
    const { name, subject, portions, amount } = this;
    const item = {
      name,
      subject,
      portions,
      lockerId: this.locker.id,
      typeId: this.type.id,
      amount
    };

    const data = await this.$store.dispatch("createItem", item);

    this.handleReqFeedback(data);
  }

  private handleReqFeedback(data: ItemWrite) {
    if (typeof data !== "undefined") this.$router.back();
    else {
      alert(data);
    }
  }

  private async save() {
    const { name, subject, portions, id } = this;
    const { item } = this.$store.state;
    let lockerId = this.locker.id;
    if (typeof lockerId === "undefined" || !lockerId) lockerId = item.locker.id;

    let typeId = this.type.id;
    if (typeof typeId === "undefined" || !typeId) typeId = item.type.id;

    const newItem = {
      name,
      subject,
      portions,
      lockerId,
      typeId: this.type.id,
      amount: 1
    } as ItemWrite;

    const data = await this.$store.dispatch("updateItem", {
      id: id,
      item: newItem
    });

    this.handleReqFeedback(data);
  }

  private async setItemData() {
    const { item, lockers } = this.$store.state;
    if (typeof item.name === "undefined") {
      await this.$store.dispatch("itemDetail", { id: this.id });
    }
    const { name, subject, portions, type, locker } = this.$store.state.item;
    this.name = name;
    this.portions = portions;
    this.lockers = lockers;
    this.locker = locker.id;

    this.subjects = locker.subjects;
    this.subject = subject;

    this.type = type;
  }
}
